const phoneReg =
  /((\+7)-?)?\(?\d{3}\)?-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}-?\d{1}/

export const phoneValidator = (value: string): string => {
  const v = value ? value.replace(/[^\d]/g, '') : value
  return v && !phoneReg.test(v) ? 'Некорректный телефон' : ''
}

export const emailValidator = (value: string): string =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Неверный email'
    : ''
